export default __webpack_public_path__ + "static/media/132_vochaos.e106169d.webp";